<template>
  <base-content>
    <template v-slot:top>
      <hero-header heading="Transactions" />
    </template>
    <template v-if="transactions && !loading">
      <base-table>
        <thead>
          <tr>
            <th>User</th>
            <th>Description</th>
            <th>Amount</th>
            <th>Date</th>
            <th>Status</th>
            <th>Message</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(transaction, key) in transactions" :key="key">
            <td>
              <router-link :to="{ name: 'users.dashboard', params: { id: transaction.user._id } }">
                {{ transaction.user.email }}
              </router-link>
            </td>
            <td>{{ transaction.type.description }}</td>
            <td>{{ $formatting.toCurrency(transaction.amount) }}</td>
            <td>{{ $dates.toDateTime(transaction.transactionAt) }}</td>
            <td>
              <span v-if="transaction.status === 'SUCCESS'" class="text-success">
                {{ transaction.status }}
              </span>
              <span v-else-if="transaction.status === 'FAILED'" class="text-danger" v-tooltip="transaction.message">
                {{ transaction.status }}
              </span>
              <span v-else>
                {{ transaction.status }}
              </span>
            </td>
            <td>{{ transaction.message }}</td>
            <td>
              <base-button v-if="transaction.status === 'SUCCESS' && transaction.type.refundable && transaction.refund !== null" secondary small @click="confirmation(transaction)">
                Refund
              </base-button>
            </td>
          </tr>
        </tbody>
      </base-table>
      <div class="mt-4">
        <base-pagination :current="page" :total="pages" @go="request" />
      </div>
    </template>
    <template v-else-if="!loading">
      <p class="text-center">No transactions found.</p>
    </template>
    <template v-else>
      <base-loader />
    </template>
  </base-content>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import HeroHeader from '@/components/HeroHeader.vue'

export default {
  components: {
    HeroHeader
  },

  data: () => ({
    page: 1
  }),

  created () {
    this.request()
  },

  computed: {
    ...mapState({
      loading: store => store.core.transactions.isListPending,
      pages: store => store.core.transactions.totalPages,
      transactions: store => store.core.transactions.rows
    })
  },

  methods: {
    confirmation (transaction) {
      this.$dialog.confirm('Are you sure you wish to refund this transaction?', async () => {
        await this.refund({ id: transaction._id })
        await this.request(this.page)
      })
    },

    request (page) {
      if (page) {
        this.page = page
      }

      this.get({
        page: this.page,
        populate: ['user'],
        showHidden: true
      })
    },

    ...mapActions({
      get: 'core/transactions/list',
      refund: 'core/transactions/refund'
    })
  }
}
</script>
